export default __webpack_public_path__ + "static/media/fact_sheet32.3aad7835.png";